import { CatIconArrowTriangularRight } from '@blocks-react/components/Icons/ArrowTriangularRight';
import { StoreHoursInfoDetailsProps } from './types';
import cx from 'classnames';
import styles from '../store-hours-info.module.scss';

export const StoreHoursInfoDetails = ({
  storeHoursInfoDetails: { label, currentDay, value },
  locale
}: StoreHoursInfoDetailsProps) => {
  const covertStartEndTimeIn24hr = (startTimeAndEndTime: string) => {
    try {
      const storehours = startTimeAndEndTime?.split(' - ');
      return storehours?.map((item) => convertTimeInto24hr(item)).join(' - ');
    } catch (error) {
      return startTimeAndEndTime;
    }
  };
  const convertTimeInto24hr = (time12hrs: string) => {
    try {
      const [timeZone, identifier] = time12hrs.split(' ');
      let [hours, minutes] = timeZone.split(':');
      if (!hours || !minutes) {
        return time12hrs;
      }
      if (hours === '12') {
        hours = '00';
      }
      if (identifier === 'PM') {
        hours = `${parseInt(hours, 10) + 12}`;
      }
      return `${hours}:${minutes}`;
    } catch (error) {
      return time12hrs;
    }
  };
  return (
    <div className="d-flex flex-row text-sm mb-1" key={label}>
      <div
        className={cx('d-flex flex-row flex-grow-1 text-start mb-0', {
          'align-items-center': !!currentDay
        })}
      >
        {currentDay ? (
          <CatIconArrowTriangularRight
            data-testid="cat-triangle-icon"
            slot="before"
          />
        ) : null}
        <p
          className={cx('m-0 exclude-global', styles['store-hours-info-text'], {
            'cat-u-theme-typography-label': !!currentDay,
            'cat-u-theme-typography-body-sm': !currentDay
          })}
        >
          {label}
        </p>
      </div>
      <p
        className={cx(
          'flex-grow-1 text-end mb-0 exclude-global',
          styles['store-hours-info-text'],
          {
            'cat-u-theme-typography-label': !!currentDay,
            'cat-u-theme-typography-body-sm': !currentDay
          }
        )}
      >
        {locale === 'uk_UA' ? covertStartEndTimeIn24hr(value) : value}
      </p>
    </div>
  );
};
